<template>
  <div class="cover-container w-100 mx-auto">
    <main class="px-3">
      <div class="btn_area">
        <h1>請用手機開啟頁面</h1>
        <div class="btn_css" @click="dirTo()">確認</div>
      </div>
    </main>
  </div>
</template>

<script>
import { isMobile } from '@/utils/deviceDetection'
import { getDeviceInfo } from '@/utils/deviceDetection'
export default {
  name: 'Mobile',
  methods :{
    dirTo(){
      console.log(getDeviceInfo());
      (isMobile()) ? this.$router.push('/') : '';
    }
  }
}
</script>
<style scoped>
h1{
  color: white;
}
.btn_area {
  text-align: center;
  position: relative;
  width: 80%;
  max-width: 800px;
  margin: auto;
  margin-top: 40vh;
}

.btn_css {
  width: 50%;
  margin: 10% auto;
  font-size: 1.2rem;
  border-radius: 8px;
  box-shadow: 0 0px 0px , 2px 2px 10px #222;
  background: #436ab2;
  padding: 8px 30px;
  font-weight: 500;
  color: white;
  max-width: 200px;
}

.btn_css:active {
  box-shadow: 0 0px 0px red, 4px 4px 4px #e8e7b5, 5px 8px 2px 1px #8CB9FE, 0 0 0px green;
  background: linear-gradient(#4a4170, #27213b);
  color: white;
}
</style>
